"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */

const IconWithBackground = ({
  icon,
  variant
}) => (0, _jsxRuntime.jsx)("span", {
  css: [_styles.withBackGroundStyles.default, variant === 'delete' && _styles.withBackGroundStyles.delete, variant === 'isMainImage' && _styles.withBackGroundStyles.isMainImage, variant === 'setMainImage' && _styles.withBackGroundStyles.setMainImage, variant === 'imageUpload' && _styles.withBackGroundStyles.imageUpload, process.env.NODE_ENV === "production" ? "" : ";label:IconWithBackground;"],
  children: /*#__PURE__*/(0, _react.cloneElement)(icon, {
    size: 25
  })
});
var _default = exports.default = IconWithBackground;